import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-danvi-slider-logo",
  templateUrl: "./danvi-slider-logo.component.html",
  styleUrls: ["./danvi-slider-logo.component.scss"],
})
export class DanviSliderLogoComponent implements OnInit {
  logos = [
    { background: "#fcfcfd", svg: "assets/img/danvi/logo-danvi-dark.svg" },
  ];

  slideConfig = {
    dots: false,
    arrows: false,
  };
  constructor() {}

  ngOnInit() {}
}
